import React, { SVGAttributes } from 'react';

export function OrderProcessingIcon(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg height={56} width={56} xmlns='http://www.w3.org/2000/svg' fill='none' {...props}>
      <g strokeLinecap='round' strokeLinejoin='round' strokeWidth='2.333' clipPath='url(#a)'>
        <path
          stroke='#464F53'
          d='M25.999 8h-16a2.667 2.667 0 0 0-2.667 2.666v8a2.667 2.667 0 0 0 2.667 2.667h16a2.667 2.667 0 0 0 2.666-2.666v-8A2.667 2.667 0 0 0 26 8ZM17.998 21.333v5.334M13.998 26.666h8M44.666 26.666h-8a2.667 2.667 0 0 0-2.667 2.667v16A2.667 2.667 0 0 0 36.666 48h8a2.667 2.667 0 0 0 2.666-2.667v-16a2.667 2.667 0 0 0-2.666-2.666ZM33.999 41.778h13.333'
        />
        <path
          stroke='#00A47C'
          d='M12.665 34.667a10.667 10.667 0 0 0 10.667 10.666h4M47.332 21.333a10.667 10.667 0 0 0-10.666-10.666h-2.667'
        />
        <path stroke='#00A47C' d='m36.666 8-2.667 2.666 2.667 2.667M24.666 48l2.667-2.667-2.667-2.666' />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M6 6.667h42.667v42.667H6z' />
        </clipPath>
      </defs>
    </svg>
  );
}
